import { useState } from 'react';
import { Rocket, Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { usePlatform } from '../../context/PlatformContext';

export function LaunchControls() {
  const { ordersEnabled, loading, refresh } = usePlatform();
  const [saving, setSaving] = useState(false);

  const handleToggle = async () => {
    const next = !ordersEnabled;
    const msg = next
      ? 'GO LIVE? This enables ordering & messaging for everyone.'
      : 'Return to PRE-LAUNCH? This blocks all ordering & messaging.';
    if (!window.confirm(msg)) return;
    setSaving(true);
    try {
      await api.setLaunchStatus(next);
      await refresh();
      toast.success(next ? 'Tune4Tune is LIVE! Orders & messaging enabled.' : 'Back to pre-launch mode. Orders & messaging blocked.');
    } catch (e) {
      toast.error('Failed to update launch status');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return null;

  return (
    <div className={`border rounded-xl p-4 mb-8 flex items-center justify-between gap-4 ${ordersEnabled ? 'bg-surface border-green-500/30' : 'bg-surface border-yellow-500/40'}`} data-testid="launch-controls">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${ordersEnabled ? 'bg-green-500/10' : 'bg-yellow-500/10'}`}>
          {ordersEnabled ? <Rocket className="w-5 h-5 text-green-400" /> : <Lock className="w-5 h-5 text-yellow-400" />}
        </div>
        <div>
          <p className="text-sm font-medium">
            Platform Status:
            <span className={`ml-2 text-xs font-bold ${ordersEnabled ? 'text-green-400' : 'text-yellow-400'}`} data-testid="launch-status-label">
              {ordersEnabled ? 'LIVE' : 'PRE-LAUNCH (Early Access)'}
            </span>
          </p>
          <p className="text-xs text-[#666]">
            {ordersEnabled
              ? 'Ordering & messaging are enabled for all users.'
              : 'Site is browsable, but ordering & messaging are blocked until you launch.'}
          </p>
        </div>
      </div>
      <Button
        onClick={handleToggle}
        disabled={saving}
        className={ordersEnabled ? 'bg-yellow-600 hover:bg-yellow-700 text-white' : 'bg-green-600 hover:bg-green-700 text-white'}
        data-testid="launch-toggle-btn"
      >
        {saving ? 'Saving...' : ordersEnabled ? 'Back to Pre-Launch' : 'Launch Now'}
      </Button>
    </div>
  );
}
